import { render } from "./SettingsChange.vue?vue&type=template&id=7ddc5d7a&scoped=true"
import script from "./SettingsChange.vue?vue&type=script&lang=js"
export * from "./SettingsChange.vue?vue&type=script&lang=js"

import "./SettingsChange.vue?vue&type=style&index=0&id=7ddc5d7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddc5d7a"]])

export default __exports__